export default __webpack_public_path__ + "static/media/039-great wall of china.8f45d669.svg";